import { useState } from "react";
import { ImageUp } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { IMG } from "@/lib/assets";
import { siteImg } from "@/context/AppearanceContext";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ImageCropUpload } from "@/components/admin/appearance/ImageCropUpload";
import { useAdminAppearance } from "@/components/admin/appearance/LogoBannerSettings";

const idOf = (url) => (url ? url.split("/").pop() : null);
export const SLOTS = [
  ["royal_dream", "Koin Royal Dream", IMG.rdCoin],
  ["higgs_domino_domino", "Higgs · Kartu Domino", IMG.higgsTile],
  ["higgs_domino_bingo", "Higgs · Kartu Bingo", IMG.higgsCat],
];
export const slotOf = (game, category) => (game === "royal_dream" ? "royal_dream" : category === "Kartu Bingo" ? "higgs_domino_bingo" : "higgs_domino_domino");

export const PkgDefaultImages = ({ canManage, onChange }) => {
  const [a, reload] = useAdminAppearance();
  if (!a) return null;
  const save = async (slot, id) => {
    const body = Object.fromEntries(SLOTS.map(([s]) => [s, idOf(a.pkg_images?.[s])]));
    try {
      await api.put("/admin/appearance/pkg-images", { ...body, [slot]: id });
      const d = await reload();
      onChange?.(d.pkg_images);
    } catch (err) {
      toast.error(errMsg(err, "Gagal menyimpan"));
      throw err;
    }
  };
  return (
    <div className="rk-glass space-y-3 rounded-2xl p-5" data-testid="pkg-default-images">
      <div>
        <h3 className="text-lg font-bold">Gambar Koin / Kartu Paket</h3>
        <p className="mt-1 text-xs text-zinc-500">Gambar default untuk semua paket di halaman top up, per game dan kategori. Tiap paket bisa diganti sendiri di tabel harga di bawah (kolom Gambar).</p>
      </div>
      <div className="grid gap-4 md:grid-cols-3">
        {SLOTS.map(([s, label]) => (
          <ImageCropUpload key={s} kind="pkg_image" title={label} guide="600 × 600 px" formats="WebP, PNG, JPG" aspect={1} outW={600} outH={600}
            current={a.pkg_images?.[s]} canManage={canManage} testid={`pkg-default-${s}`} onDone={(d) => save(s, d.id)} onRemove={() => save(s, null)} />
        ))}
      </div>
    </div>
  );
};

export const PkgImageCell = ({ p, game, i, defaults, canManage, set }) => {
  const [open, setOpen] = useState(false);
  const fallback = siteImg(defaults?.[slotOf(game, p.category)]) || SLOTS.find(([s]) => s === slotOf(game, p.category))[2];
  return (
    <div className="flex items-center gap-2">
      <img src={p.image_url ? siteImg(p.image_url) : fallback} alt="" className={`h-10 w-10 rounded-md object-cover ${p.image ? "ring-2 ring-[#e5b80b]" : "opacity-70"}`} data-testid={`pkg-img-thumb-${game}-${i}`} />
      {canManage ? (
        <button type="button" onClick={() => setOpen(true)} className="rk-btn-ghost inline-flex items-center gap-1 !px-2 !py-1 text-[11px]" data-testid={`pkg-img-edit-${game}-${i}`}>
          <ImageUp size={11} /> {p.image ? "Ganti" : "Default"}
        </button>
      ) : null}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md border-white/10 bg-[#101017] text-white">
          <DialogHeader>
            <DialogTitle>Gambar paket {p.label || "baru"}</DialogTitle>
            <DialogDescription className="text-xs text-zinc-500">Kosongkan untuk memakai gambar default kategori. Klik "Simpan Harga" setelahnya.</DialogDescription>
          </DialogHeader>
          <ImageCropUpload kind="pkg_image" title="Gambar khusus paket" guide="600 × 600 px" formats="WebP, PNG, JPG" aspect={1} outW={600} outH={600}
            current={p.image_url} canManage={canManage} testid={`pkg-img-upload-${game}-${i}`}
            onDone={(d) => { set({ image: d.id, image_url: d.url }); setOpen(false); }}
            onRemove={() => { set({ image: null, image_url: null }); setOpen(false); }} />
        </DialogContent>
      </Dialog>
    </div>
  );
};
